export default function disclosure () {
  const WRAPPERS = document.querySelectorAll('.mtt-slider-with-disclosure')

  if (WRAPPERS.length) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const WRAPPER = WRAPPERS[i]

      new Disclosure(WRAPPER)
    }
  }
}

class Disclosure {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.INNER = this.WRAPPER.querySelector('.mtt-slider-with-disclosure__inner')
    this.DISCLOSURE_BUTTONS = this.WRAPPER.querySelectorAll('.mtt-slider-with-disclosure__disclosure-button')
    this.DISCLOSURE_CONTENT = this.WRAPPER.querySelector('.mtt-slider-with-disclosure__disclosure-wrapper')
    this.DISCLOSURE_CLOSE_BUTTON = this.WRAPPER.querySelector('.mtt-slider-with-disclosure__disclosure-close-icon div')

    if (this.DISCLOSURE_BUTTONS.length > 0) {
      for (let i = 0; i < this.DISCLOSURE_BUTTONS.length; i++) {
        const BUTTON = this.DISCLOSURE_BUTTONS[i]

        this.addDisclosureClick(BUTTON)
      }
    }

    if (this.DISCLOSURE_CLOSE_BUTTON) {
      this.closeDisclosure()
    }
  }

  addDisclosureClick (BUTTON) {
    BUTTON.addEventListener('click', () => {
      if (this.DISCLOSURE_CONTENT.classList.contains('hide')) {
        this.DISCLOSURE_CONTENT.classList.remove('hide')
        BUTTON.classList.add('open')
        this.DISCLOSURE_CONTENT.scrollIntoView({ behavior: 'smooth' })
      } else {
        this.DISCLOSURE_CONTENT.classList.add('hide')
        BUTTON.classList.remove('open')
      }
    })
  }

  closeDisclosure () {
    this.DISCLOSURE_CLOSE_BUTTON.addEventListener('click', (e) => {
      this.DISCLOSURE_CONTENT.classList.add('hide')
      if (this.DISCLOSURE_BUTTONS.length > 0) {
        for (let i = 0; i < this.DISCLOSURE_BUTTONS.length; i++) {
          const BUTTON = this.DISCLOSURE_BUTTONS[i]
          if (BUTTON.classList.contains('open')) {
            BUTTON.classList.remove('open')
          }
        }
      }
      this.INNER.scrollIntoView({ behavior: 'smooth' })
    })
  }
}
